import http from '@/util/http'
// import { isWorkPhone } from '@/util'
import Vue from 'vue'
import Toast from '@/components/toast/toast'
import Cookies from 'js-cookie'
import toastZH from '@/store/language/cn/toast'
import toastEN from '@/store/language/en/toast'

Vue.use(Toast)

let vue = new Vue()

let token = (localStorage && localStorage.getItem('token')) || ''

let fdkankantoken = Cookies.get('4dkankantoken') || ''
let cart = (localStorage && localStorage.getItem('cart')) || []
let invoice2 = (localStorage && localStorage.getItem('invoice2')) || []
let invoice3 = (localStorage && localStorage.getItem('invoice3')) || []
let deviceLogin = (localStorage && localStorage.getItem('deviceLogin')) || ''

let dataObj = {
  info: {},
  address: {}
}

try {
  Object.keys(dataObj).forEach(key => {
    dataObj[key] = localStorage && JSON.parse(localStorage.getItem(key))
  })
} catch (error) {
}

export default {
  state: {
    token: token,
    fdkankantoken,
    name: null,
    cart: cart,
    cameradetail: '',
    myscene: '',
    mydevice: '',
    myexpansion: '',
    mycharge: '',
    myinvoicelist: '',
    myorder: '',
    deviceLogin,
    invoicedevice: '',
    invoice2: invoice2,
    invoice3: invoice3,
    ...dataObj
  },

  mutations: {
    saveToken (state, token) {
      state.token = token
      try {
        Cookies.set('fdkankantoken', token)
        localStorage.setItem('token', token)
      } catch (error) {

      }
    },

    logout (state) {
      try {
        Cookies.set('fdkankantoken', '')
        Object.keys(state).forEach(key => {
          state[key] = ''
          localStorage.setItem(key, '')
        })
      } catch (error) {
      }
    },

    info (state, data) {
      localStorage.setItem(data.name, JSON.stringify(data.val))
      state[data.name] = data.val
    },

    myScene (state, data) {
      state.myscene = data
      localStorage.setItem('myscene', JSON.stringify(data))
    },

    INVOICEDEVICE (state, data) {
      state.invoicedevice = data
      localStorage.setItem('invoicedevice', JSON.stringify(data))
    },
    MYDEVICE (state, data) {
      state.mydevice = data
      localStorage.setItem('mydevice', JSON.stringify(data))
    },

    CAMERADERTAIL (state, data) {
      state.cameradetail = data
      localStorage.setItem('cameradetail', JSON.stringify(data))
    },

    MYEXPANSION (state, data) {
      state.myexpansion = data
      localStorage.setItem('myexpansion', JSON.stringify(data))
    },

    MYCHARGE (state, data) {
      state.mycharge = data
      localStorage.setItem('mycharge', JSON.stringify(data))
    },
    MYINVOICELIST (state, data) {
      state.myinvoicelist = data
      localStorage.setItem('myinvoicelist', JSON.stringify(data))
    },

    INVOICE (state, data) {
      state[`invoice${data.type}`] = data.data
      localStorage.setItem(`invoice${data.type}`, JSON.stringify(data.data))
    },

    CART (state, data) {
      state.cart = data
      localStorage.setItem('cart', JSON.stringify(data))
    },

    myOrder (state, data) {
      state.myorder = data
      localStorage.setItem('myorder', JSON.stringify(data))
    },

    user_not_login (state) {
      state.name = null
    },

    DEVICELOGIN (state, data) {
      state.deviceLogin = data
      localStorage.setItem('deviceLogin', data)
    }
  },

  actions: {
    async getInfo (context, data) {
      let info = await http({
        method: 'post',
        headers: {
          token: context.state.token
        },
        url: data.url
      })
      if (info.data.code === 0) {
        let obj = {
          name: data.name,
          val: info.data.data
        }
        context.commit('info', obj)
      }
    },
    async codeLogin (context, params) {
      let toastCode = localStorage.getItem('language') === 'en' ? toastEN : toastZH
      let res = await http({
        method: 'post',
        data: params,
        url: '/sso/user/quickLogin'
      })

      let data = res.data
      if (data.code !== 0) {
        return vue.$toast.show('warn', toastCode[data.code])
      }
      let token = data.data.token
      context.commit('saveToken', token)
      if (token) {
        context.commit('DEVICELOGIN', '')
        context.dispatch('getInfo', {url: '/user/getUserInfo', name: 'info'})
        context.dispatch('getCart')
      }
    },
    async login (context, params) {
      let toastCode = localStorage.getItem('language') === 'en' ? toastEN : toastZH

      let res = await http({
        method: 'post',
        data: params,
        url: '/sso/user/login'
      })

      let data = res.data
      if (data.code !== 0) {
        return vue.$toast.show('warn', toastCode[data.code])
      }
      let token = data.data.token
      context.commit('saveToken', token)
      if (token) {
        context.commit('DEVICELOGIN', '')
        context.dispatch('getInfo', {url: '/user/getUserInfo', name: 'info'})
        context.dispatch('getCart')
      }
    },
    async logout (context, params) {
      let toastCode = localStorage.getItem('language') === 'en' ? toastEN : toastZH
      let res = await http({
        method: 'post',
        headers: {
          token: context.state.token
        },
        url: '/sso/user/logout'
      })

      let data = res.data
      if (data.code !== 0) {
        return vue.$toast.show('warn', toastCode[data.code])
      }
      context.commit('logout')
    },
    async checkToken (context, params) {
      let res = await http({
        method: 'post',
        headers: {
          token: context.state.token
        },
        url: '/user/checkToken'
      })

      let data = res.data
      if (data.code !== 0) {
        context.commit('logout')
        return true
      }
      return false
    },
    async reduceCart (context, params) {
      let toastCode = localStorage.getItem('language') === 'en' ? toastEN : toastZH
      let res = await http({
        method: 'post',
        data: params,
        headers: {
          token: context.state.token
        },
        url: '/user/cart/remove'
      })
      let data = res.data
      if (data.code !== 0) {
        return vue.$toast.show('warn', toastCode[data.code])
      }
      context.dispatch('getCart')
    },
    async addCart (context, params) {
      let toastCode = localStorage.getItem('language') === 'en' ? toastEN : toastZH
      let res = await http({
        method: 'post',
        data: params,
        headers: {
          token: context.state.token
        },
        url: '/user/cart/add'
      })
      let data = res.data
      if (data.code !== 0) {
        return vue.$toast.show('warn', toastCode[data.code])
      }
      context.dispatch('getCart')
    },
    async getCart (context, params) {
      let info = await http({
        method: 'post',
        headers: {
          token: context.state.token
        },
        url: '/user/cart/list'
      })
      if (info.data.code !== 0) return
      context.commit('CART', info.data.data)
    },

    async getInvoice (context, data) {
      let info = await http({
        method: 'post',
        data: data.params,
        headers: {
          token: context.state.token
        },
        url: '/user/invoice/mine'
      })
      if (info.data.code !== 0) return
      context.commit('INVOICE', {type: data.type, data: info.data.data})
    },

    async getUserDevice (context, params) {
      let res = await http({
        method: 'post',
        data: params,
        headers: {
          token: context.state.token
        },
        url: '/user/camera/list'
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('MYDEVICE', data.data)
    },

    async getInvoiceDevice (context, params) {
      let res = await http({
        method: 'post',
        data: params,
        headers: {
          token: context.state.token
        },
        url: '/user/camera/getAll'
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('INVOICEDEVICE', data.data)
    },

    async getUserExpansion (context, params) {
      let res = await http({
        method: 'post',
        data: params.params,
        headers: {
          token: context.state.token
        },
        url: params.url
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('MYEXPANSION', data.data)
    },

    async getChargeList (context, params) {
      let res = await http({
        method: 'post',
        data: params.params,
        headers: {
          token: context.state.token
        },
        url: params.url
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('MYCHARGE', data.data)
    },

    async getInvoiceList (context, params) {
      let res = await http({
        method: 'post',
        data: params.params,
        headers: {
          token: context.state.token
        },
        url: params.url
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('MYINVOICELIST', data.data)
    },

    async getUserScene (context, params) {
      let res = await http({
        method: 'post',
        data: params,
        headers: {
          token: context.state.token
        },
        url: '/user/scene/list'
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('myScene', data.data)
    },

    async getScanScene (context, params) {
      let res = await http({
        method: 'post',
        data: params,
        headers: {
          token: context.state.token
        },
        url: '/device/scene/list'
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('myScene', data.data)
    },

    async getUserOrder (context, params) {
      let res = await http({
        method: 'post',
        data: params,
        headers: {
          token: context.state.token
        },
        url: '/user/order/list'
      })

      let data = res.data
      if (data.code !== 0) return
      context.commit('myOrder', data.data)
    },
    async getAuthCode (context, item) {
      let toastCode = localStorage.getItem('language') === 'en' ? toastEN : toastZH

      let {phone, code, type = ''} = item
      let areaNum = Number(code) || 86

      if (phone) {
        let resp = await http
          .post('/sso/user/checkUser', {phoneNum: phone})

        switch (type) {
          case 'resigter':
            if (resp.data.code === 0) {
              return vue.$toast.show('warn', toastCode[3008])
            }
            break

          default:
            if (resp.data.code !== 0) {
              return vue.$toast.show('warn', toastCode[resp.data.code])
            }
            break
        }
        let params = {
          phoneNum: Number(phone),
          areaNum
        }
        http({
          method: 'post',
          data: params,
          url: '/sso/user/getMsgAuthCode'
        }, res => {
        })
        return true
      } else {
        return vue.$toast.show('warn', toastCode['29'])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js